module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABBSURBVHgBvYxBDQAgDAMXFCAFaTgAR0hBChLKHjz2Y0u2NemnuStRegBs7rAIjXtSpS73onDrlxDv0xd+wlLDIbl7zENgL1fFzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/youjiantou.png
// module id = r3KL
// module chunks = 1